import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import translate from '../utils/utils';
const ExpandableSection = ({ toggleText, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs("div", { children: [_jsxs("button", { type: "button", style: { cursor: 'pointer', backgroundColor: 'transparent', color: 'var(--accent-blue)' }, onClick: () => setIsOpen(!isOpen), children: [_jsx("i", { className: isOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down', style: { marginRight: '0.5rem' } }), _jsx("span", { children: translate(toggleText) })] }), isOpen && children] }));
};
export default ExpandableSection;
